import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { stripLangPrefix } from "@/hooks/useLocalizedPath";

const BASE_URL = "https://gogenia.ai";

/**
 * Generates hreflang and canonical tags for the current page.
 * Automatically computes FR and EN variants from current path.
 */
const HreflangTags = () => {
  const location = useLocation();
  const basePath = stripLangPrefix(location.pathname);
  
  // Normalize trailing slashes
  const frUrl = `${BASE_URL}/fr${basePath === "/" ? "" : basePath}`;
  const enUrl = `${BASE_URL}/en${basePath === "/" ? "" : basePath}`;

  return (
    <Helmet>
      <link rel="alternate" hrefLang="fr" href={frUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={frUrl} />
    </Helmet>
  );
};

export default HreflangTags;
